// Resolves admin block route helpers based on (siteContext, kind/category).
// Every site context (code_medical_center included) has the same set of
// per-context block routes (admin_<context>_<kind>_blocks), so resolution is a
// simple interpolation. code_medical_center is the fallback for blank/unknown
// contexts.

const DEFAULT_SITE_CONTEXT = 'code_medical_center';
const CATEGORY_KINDS = ['footer', 'header', 'carousel', 'features', 'cta', 'content'];
const LAYOUT_CATEGORY = 'layout';

function resolvePrefix(siteContext) {
  return siteContext || DEFAULT_SITE_CONTEXT;
}

export function getBlocksIndexRoute(routes, siteContext, kind) {
  const prefix = resolvePrefix(siteContext);

  if (CATEGORY_KINDS.includes(kind)) {
    const categoryFn = routes[`admin_${prefix}_${kind}_blocks`];
    if (categoryFn) return categoryFn();
  }

  const indexFn = routes[`admin_${prefix}_blocks`];
  return indexFn ? indexFn() : routes.admin_blocks({ kind });
}

export function getNewBlockRoute(routes, siteContext, kind) {
  const prefix = resolvePrefix(siteContext);
  const newFn = routes[`new_admin_${prefix}_block`];
  return newFn ? newFn({ kind }) : routes.new_admin_block({ kind });
}

export function getBuildBlockRoute(routes, siteContext, templateId) {
  const prefix = resolvePrefix(siteContext);
  const buildFn = routes[`build_block_admin_${prefix}_blocks`];
  return buildFn
    ? buildFn({ template_id: templateId })
    : routes.build_admin_blocks({ template_id: templateId });
}

export function getEditBlockRoute(routes, siteContext, blockId, kind = null) {
  if (kind === LAYOUT_CATEGORY) {
    return routes.edit_admin_block(blockId);
  }

  const prefix = resolvePrefix(siteContext);
  const editFn = routes[`edit_admin_${prefix}_block`];
  return editFn ? editFn(blockId) : routes.edit_admin_block(blockId);
}

export function getUpdateBlockRoute(routes, siteContext, blockId, kind = null) {
  if (kind === LAYOUT_CATEGORY) {
    return routes.admin_block(blockId);
  }

  const prefix = resolvePrefix(siteContext);
  const updateFn = routes[`admin_${prefix}_block`];
  return updateFn ? updateFn(blockId) : routes.admin_block(blockId);
}

export function getDestroyBlockRoute(routes, siteContext, blockId, kind = null) {
  return getUpdateBlockRoute(routes, siteContext, blockId, kind);
}

export function getCreateBlockRoute(routes, siteContext) {
  const prefix = resolvePrefix(siteContext);
  const createFn = routes[`admin_${prefix}_blocks`];
  return createFn ? createFn() : routes.admin_blocks();
}
